import { Dropdown } from 'react-bootstrap';
import React, { useState } from 'react';
import * as DateFns from 'date-fns';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment-timezone';
import { Link, useLocation } from 'react-router-dom';

import { getFile, isOSULacrosse, paramBuilder, getDataScope } from '../../../helpers';
import PositionFilter from '../../Shared/Filters/PositionFilter';
import SimpleMultiSelector from '../../Shared/Filters/SimpleMultiSelector';
import {
  BALL,
  FILTER_KEYS,
  FLIGHT,
  FUTURE_PRACTICE,
  LIVE_PRACTICE,
  POSITION_LACROSSE,
  SPEED_ZONE_TYPE,
  VIEW_BY_PLAYER,
  VIEW_SPEED_ZONE,
  PAST_GAME,
  QUARTER,
  GAME
} from '../../../config/constants';
import TabSelector from '../../Shared/Filters/TabSelector';
import { SERVER } from '../../../config/server.config';
import ConfirmationModal from '../../Shared/Modals/ConfirmationModal';
import PositionLacrosseFilter from '../../Shared/Filters/PositionLacrosseFilter';
import { useRouter } from '../../../helpers/customHooks';
import { useDataEventsState, useFiltersState } from '../../../store/hooks';
import { FiltersTabBallMetricsPropsType } from './types';
import { message, notification } from 'antd';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { PerformanceRoutes } from '../TabPerformance/types';

export const FiltersTabBallMetrics = ({ loadData, teamId, isInProgress }: FiltersTabBallMetricsPropsType) => {

  const { params, pathname, viewPracticeGamePageScope } = useRouter<{ params: { id: string, tab: string } }>();
  const {
   params: gameParams
  } = useRouter<PerformanceRoutes>();
  const { id, tab } = params;
  const { dataEvent: data } = useDataEventsState();
  const dataScope = getDataScope(gameParams.teamId);
  const view = new URLSearchParams(useLocation().search).get('view');
  const [showFilter, setShowFilter] = useState(-1);
  const [modal, setModal] = useState<JSX.Element | null>(null);
  const paramFilters = useFiltersState(viewPracticeGamePageScope);
  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();

  // Exports Notification
  const notificationKey = 'downloadFinished';
  const notificationDownload = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download In Progress',
      description:
        `Your file ${name} is being processed.`,
      duration: 0,
      icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadFinish = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download Finished',
      description: `Your file ${name} has been downloaded successfully.`,
      duration: 4,
      icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadError = (name:string) => {
    const args = {
      key: notificationKey,
      message: `Error downloading file ${name}`,
      duration: 4,
      icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
    };
    notification.open(args);
  };

  const timeUpdated = data.meta.type === LIVE_PRACTICE || isInProgress ? data.meta.dateUpdated : data.meta.type !== PAST_GAME? 
  data.data.highlights.updateTimestamp : data[dataScope].highlights.updateTimestamp;
  const close = () => setShowFilter(-1);
  const exportCsv = async (filtered: boolean, isTotals: boolean) => {
    const params = { ...(filtered ? paramFilters : {}), teamId };
    const localDate = new Date(data.meta.startTime);
    params['tzOffset'] = -localDate.getTimezoneOffset();
    fileIsDownloading(true);
    notificationDownload(`${id}.csv`);
    const done = await getFile(
      (isTotals ? (
          SERVER.CSV_REPORT_BALLFLIGHTS_TOTALS(id) +
          paramBuilder({ tzOffset: -(new Date(data.meta.startTime).getTimezoneOffset()) }) +
          (data.meta.type === LIVE_PRACTICE ? '&isLive=yes' : data.meta.type === PAST_GAME? `&teamOfInterest=${gameParams.teamId}`: '')
        ) : (
          SERVER.CSV_REPORT_BALLFLIGHTS(id) +
          paramBuilder(params) +
          (data.meta.type === LIVE_PRACTICE ? '&isLive=yes' : data.meta.type === PAST_GAME? `&teamOfInterest=${gameParams.teamId}`: '')
        )
      ), `${id}.csv`);
    if (done) {
      fileIsDownloading(false);
      notificationDownloadFinish(`${id}.csv`);
    } else {
      fileIsDownloading(false);
      notificationDownloadError(`${id}.csv`);
    }
  };

  const periods = [...((data && data.meta && data.meta.drills) || [])];
  if (tab === BALL) {
    periods.unshift({
      drillType: 'Ball Pre-Practice',
      endTs: 0,
      session_id: 0,
      startTs: 0,
      state: ''
    });
  }
  return (
    <>
      {modal}
      <div className="head-filters-01 switch-008" style={{ paddingLeft: '187px', height: '66px' }}>
        <TabSelector show={showFilter === 5} close={close} open={() => setShowFilter(5)} />
        {data.meta.type !== FUTURE_PRACTICE ? isOSULacrosse(teamId) ?
          <PositionLacrosseFilter
            type={POSITION_LACROSSE}
            show={showFilter === 1}
            close={close}
            open={() => setShowFilter(1)}
            // comesFromBallMetrics not used
            forceScope={viewPracticeGamePageScope}
          /> :
          <PositionFilter
            show={showFilter === 1}
            close={close}
            open={() => setShowFilter(1)}
            forceScope={viewPracticeGamePageScope}
          /> : null}
        {(data.meta.type !== FUTURE_PRACTICE && data.meta.type !== LIVE_PRACTICE &&
        data.meta.type !== PAST_GAME) && (
          <SimpleMultiSelector
            type={{
              name: 'Period',
              types: periods.map((period) => ({ value: period, name: period.drillType })),
              title: 'PERIOD',
              filterKey: FILTER_KEYS.PERIODS
            }}
            show={showFilter === 2}
            close={close}
            open={() => setShowFilter(2)}
            onApply={loadData}
            forceScope={viewPracticeGamePageScope}
          />
        )}
        {(data.meta.type === PAST_GAME)&&(
        <SimpleMultiSelector
          type={QUARTER}
          show={showFilter === 2}
          close={close}
          open={() => setShowFilter(2)}
          onApply={loadData}
          forceScope={viewPracticeGamePageScope}
        />)}
        {data.meta.type !== FUTURE_PRACTICE && (
          <>
            <SimpleMultiSelector
              type={FLIGHT}
              show={showFilter === 3}
              close={close}
              open={() => setShowFilter(3)}
              onApply={loadData}
              forceScope={viewPracticeGamePageScope}
            />
            {view === VIEW_SPEED_ZONE && (
              <SimpleMultiSelector
                type={SPEED_ZONE_TYPE}
                show={showFilter === 4}
                close={close}
                open={() => setShowFilter(4)}
                forceScope={viewPracticeGamePageScope}
              />
            )}
            <Link
              to={{ pathname, search: view === VIEW_BY_PLAYER ? '' : '?view=byPlayer' }}
              style={{ position: 'absolute', right: '420px' }}
              className="mobile-display"
            >
              <label
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: 'bold',
                  color: '#333D47',
                  fontSize: '11.9px',
                  paddingTop: '12px',
                  paddingLeft: '30px'
                }}
                color="#383d40"
              >
                Group By: Player
              </label>
              <input
                type="checkbox"
                id="id-name--1"
                name="set-name"
                className="switch-input"
                checked={view === VIEW_BY_PLAYER}
              />
              <label htmlFor="id-name--1" className="switch-label" style={{ top: '4px' }} />
            </Link>
            <Link
              to={{ pathname, search: view === VIEW_SPEED_ZONE ? '' : '?view=speedZone' }}
              style={{ position: 'absolute', right: '280px' }}
              className="mobile-display"
            >
              <label
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: 'bold',
                  color: '#333D47',
                  fontSize: '11.9px',
                  paddingTop: '12px',
                  paddingLeft: '30px'
                }}
                color="#383d40"
              >
                Speed Zone
              </label>
              <input
                type="checkbox"
                id="id-name--1-sz"
                name="set-name-sz"
                className="switch-input"
                checked={view === VIEW_SPEED_ZONE}
              />
              <label htmlFor="id-name--1-sz" className="switch-label" style={{ top: '4px' }} />
            </Link>
            <div className="p-left">
              {/*<label className="l-date">Data last updated: {dateFns.format(new Date(timeUpdated), 'HH:mm')}</label>*/}
              {data.meta.type !== FUTURE_PRACTICE && data.meta.type !== GAME && data.meta.type !== PAST_GAME && (
                <label className="l-date">Data last
                updated: {timeUpdated ? DateFns.format(new Date(timeUpdated), 'MM/dd/yyyy hh:mm:ssaaaaa') + 'm ' : ''}{timeUpdated ? moment.tz(moment.tz.guess()).format('z') : ''}</label>
              )}
              <Dropdown className="a-export">
                <Dropdown.Toggle id="dropdown-basic" className="btn-blue" disabled={download}>
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      exportCsv(false, false);}}
                    target={'_blank'}
                  >
                    Individual Flights Export
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => {
                    exportCsv(true, true);}}>Flight Totals Export</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </>
        )}
      </div>
    </>
  );
};
